const ROUTE_STRINGS = {
  login: '/',
  resetViaPhone: 'authMod=reset_password_phone',
  resetViaEmail: 'authMod=reset_password_email',
  dashboard: '/admin',
  profile: '/admin/profile',
  coffeeentries: '/admin/coffeeentries',
  differentialsentry: '/admin/differentialsentry',
  freightrateentry: '/admin/freightrateentry',
  listNewsFeed: '/admin/listNewsFeed',
  addnewsfeed: '/admin/addnewsfeed',
  editNewsFeed: '/admin/editnewsfeed',
  newsreadmore: '/admin/newsreadmore',
  editadminnewsfeed: '/admin/editadminnewsfeed',
  newsfeedapprovalscreen: '/admin/newsfeedapprovalscreen',
  editmenugroup: '/admin/editmenugroup',
  listUsers: '/admin/listusers',
  addUser: '/admin/adduser',
  edituser: '/admin/edituser',
  userStats: '/admin/user-stats',
  edituserProfile: '/admin/edituser/',
  listmenu: '/admin/listmenu',
  addmenu: '/admin/addmenu',
  addRoles: '/admin/addrole',
  listRoles: '/admin/listroles',
  roleFeature: '/admin/role-features',
  coffeequotes: '/admin/dashboard',
  globalprice: '/admin/globalprice',
  getSubscription: '/admin/getsubscription',
  addSubscription: '/admin/addsubscription',
  editSubscription: '/admin/editsubscription',
  subscriptionfeatures: '/admin/subscriptionfeatures',
  marketdata: '/admin/marketdata',
  approveGlobalData: '/admin/approveglobaldata',
  editApprovedGlobalData: '/admin/edit-approved-globaldata',
  globaldifferentialpreview: '/admin/globaldifferentialpreview',
  globalrawdatapreview: '/admin/globalrawdatapreview',
  home: '/admin/coffeeweb',
  discover: '/admin/discover',
  connections: '/admin/connections',
  followers: '/admin/followers',
  following: '/admin/following',
  connectionRequests: '/admin/connectionrequests',
  notifications: '/admin/notifications',
  messages: '/admin/messages',
  myprofile: '/admin/myprofile',
  listPayment: '/admin/listpayment',
  mapmenu: '/admin/mapmenu',
  addPayment: '/admin/addpayment',
  editPayment: '/admin/editpayment',
  addmobile: '/admin/addmobile',
  listMobile: '/admin/listmobile',
  addLanguage: '/admin/addlanguage',
  editLanguage: '/admin/editlanguage',
  listLanguage: '/admin/listlanguage',
  listappsetting: '/admin/listappsetting',
  addScreen: '/admin/addscreen',
  listScreen: '/admin/listscreen',
  editScreen: '/admin/editscreen',
  addMapping: '/admin/addMapping',
  editMapping: '/admin/editMapping',
  listMapping: '/admin/listmapping',
  listscreenlanguage: '/admin/listscreenlanguage',
  companyapproved: '/admin/companyapproved',
  coffeepriceupload: '/admin/coffeepriceupload',
  editnews: '/admin/editnews',
  previewpdf: '/admin/previewpdf',
  addPaymentCountry: '/admin/addpaymentcountry',
  listtrendingnews: '/admin/listtrendingnews',
  // firebaseedit: '/admin/firebaseedit',
  subscriptionpaymentmapping: '/admin/subscriptionpaymentmapping',
  addTerminalDetails: '/admin/add-terminal-details',
  editTerminalDetails: '/admin/edit-terminal-details',
  listTerminalDetails: '/admin/list-terminal-details',
  addMobile: '/admin/addmobile',
  listPaymentCountry: '/admin/listpaymentcountry',
  editUser: '/admin/edituser',
  listSubscriptionPaymentMapping: '/admin/list-Subscription-Payment-Mapping',
  addSubscriptionPaymentMapping: '/admin/add-Subscription-Payment-Mapping',
  editSubscriptionPaymentMapping: '/admin/edit-Subscription-Payment-Mapping',
  subscriptionConfig: '/admin/subscription-config',
  paymentReports: '/admin/payment-report',

  // Coffee Quotes module
  coffeeQuotesIceMarket: '/admin/coffee-quotes/ice-market',
  listHoliday: '/admin/coffee-quotes/list-holiday',
  volumnInterest: '/admin/volume-interest',
  addVolumeAndInterest: '/admin/add-volume-interest-data',
  editVolumeAndInterest: '/admin/add-volume-interest',

  // Forex Data
  listForexData: '/admin/coffee-quotes/forex-data/list-forex-data',

  // Trade Invoice
  listTradeInvoice: '/admin/trade-invoice',

  reconciledReports: '/admin/reconciled-reports',

  // coffee reports
  certifiedStockReport: '/admin/certified-stock-report',
  lotReports: '/admin/lot-wise-report',
  traderWiseReport: '/admin/trader-wise-report',
  countryWiseExportReport: '/admin/country-wise-export-report',

  // USDA-COFFEE-REPORT
  listUSDACoffeeReport: '/admin/usda-coffee-report',
  addUSDACoffeeReport: '/admin/add-usda-coffee-report',
  editUSDACoffeeReport: '/admin/edit-usda-coffee-report',

  // USDA-COFFEE-REPORT
  listICOCoffeeReport: '/admin/ico-coffee-report',
  addICOCoffeeReport: '/admin/add-ico-coffee-report',
  editICOCoffeeReport: '/admin/edit-ico-coffee-report',

  weeklyWiseReports: '/admin/weekly-wise-report',

  // Missing Invoice Reports
  missingInvoiceReport: '/admin/missing-invoices-report',

  // Cancelled Invoice Report
  cancelledInvoiceReports: '/admin/cancelled-invoices-reports',

  // USER-STATS-DASHBOARD
  adminDashboard: '/admin/dashboard/user-stats',

  // Subscription Payment Report
  subscriptionPaymentReport: '/admin/subscription-payment-report',

  // Coffee Community
  coffeeCommunity: '/admin/coffee-community',
  userManagement: '/admin/user-management',
  communityManagement: '/admin/community-management',
  internalCommunitiesManagement: '/admin/internal-communities-management',
  addInternalCommunities: '/admin/add-internal-communities',
  editInternalCommunities: '/admin/edit-internal-communities',
  manageInternalUsers: '/admin/manage-internal-users',
  internalCommunityManagement: '/admin/internal-community-management',

  // Community Management
  addCommunityManagement: '/admin/coffee-social/community-management/add-community',
  userCommunityManagement: '/admin/coffee-social/community-management/community-users',
  editCommunityManagement: '/admin/coffee-social/community-management/edit-community',

  // User Management
  userManagementSetting: '/admin/coffee-social/user-management/user-settings',

  // Coffee Cast
  coffeeCast: '/admin/coffee-cast',
  addCoffeeCast: '/admin/add-coffee-cast',
  editCoffeeCast: '/admin/edit-coffee-cast',
  listOfAdmins: '/admin/list-of-admins',

  // URL Approval
  urlApproval: '/admin/url-approval',
  channelApprove: '/admin/channel-approve',
  listOfAdmin: '/admin/list-of-admin',

  // Post Approval
  PostApproval: '/admin/post-approval',

  // Freight Rates
  freightRates: '/admin/add-freight-rates-data',

  // Country Wise Production Reports
  countryWiseProductionReports: '/admin/country-wise-production-reports'
}

const TAB_MENUS = {
  // App-Settings
  settingsRoute: 'settings',
  optionsRoute: 'options',
  workBooksRoute: 'work-book',
  coffeeQuotesRoute: 'coffee-quotes',
  marketSettingsRoute: 'market-settings',
  userDashboard: 'user-dashboard',

  // List-Users
  clientsRoute: 'clients',
  contributorsRoute: 'contributors',

  // User Management
  userInformation: 'user-information',
  userSettings: 'user-settings',
  userCommunity: 'user-community'
}

export { ROUTE_STRINGS, TAB_MENUS }
